// extracted by mini-css-extract-plugin
export default {"textareaWrapper":"index__textareaWrapper___3PYKi","preview":"index__preview___-1ich"};